
import HeaderMenu from './Menu';
import HeaderUserbox from './Userbox';

import {
  Box,
  alpha,
  lighten,
  styled,
  useTheme,
  useMediaQuery
} from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { logoUrl } from 'src/content/admin/customer/logo';



const HeaderWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isMobile'
})<{ isMobile?: boolean }>(
  ({ theme, isMobile }) => `
        height: ${theme.header.height};
        color: ${theme.header.textColor};
        padding: ${theme.spacing(0, 2)};
        right: 0;
        z-index: 6;
        background-color: ${alpha(theme.header.background, 0.95)};
        backdrop-filter: blur(3px);
        position: fixed;
        justify-content: ${isMobile ? 'center' : 'space-between'};
        width: 100%;
        @media (min-width: ${theme.breakpoints.values.lg}px) {
            left: ${theme.sidebar.width};
            width: auto;
        }
`
);

function Header() {
  const isMobile = useMediaQuery('(max-width:600px)');
  const theme = useTheme();

  // Header company logo, shown next to the CKB logo. It comes straight from login:
  // the "Customer Group Name" (Dropdown 1) customer's logo, populated by the server
  // only when the user has exactly one such customer (none or multiple -> null), so
  // a single logo is never misleading. Empty string => no logo rendered.
  // (Existing sessions must re-login to receive companyLogo.)
  const user = useSelector((state: RootState) => state.Auth.user) as any;
  const customerLogo = user?.companyLogo ? logoUrl(user.companyLogo) : '';

  return (
    <HeaderWrapper
      isMobile={isMobile}
      display="flex"
      alignItems="center"
      sx={{
        bottom: isMobile ? 0 : undefined,
        boxShadow:
          theme.palette.mode === 'dark'
            ? `0 1px 0 ${alpha(
              lighten(theme.colors.primary.main, 0.7),
              0.15
            )}, 0px 2px 8px -3px rgba(0, 0, 0, 0.2), 0px 5px 22px -4px rgba(0, 0, 0, .1)`
            : `0px 2px 8px -3px ${alpha(
              theme.colors.alpha.black[100],
              0.2
            )}, 0px 5px 22px -4px ${alpha(
              theme.colors.alpha.black[100],
              0.1
            )}`
      }}
    >
      {isMobile ? (
        <>
          <HeaderMenu />
        </>
      ) : (
        <>
          <Box sx={{ flexShrink: 0, minWidth: 270 }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                pl: 2.5,
                pr: 1
              }}
            >
              <img src='/static/images/logo/ckb.png' width={100} alt="CKB" />
              {customerLogo && (
                <>
                  <Box sx={{ width: '1px', height: 32, backgroundColor: alpha(theme.colors.alpha.black[100], 0.15) }} />
                  <img
                    src={customerLogo}
                    alt="Customer logo"
                    style={{ height: 36, maxWidth: 120, objectFit: 'contain' }}
                  />
                </>
              )}
            </Box>
          </Box>
          <Box
            sx={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
              px: 2,
              minWidth: 0,
              maxWidth: '100%'
            }}
          >
            <HeaderMenu />
          </Box>
          <Box display="flex" alignItems="center" sx={{ flexShrink: 0 }}>
            <HeaderUserbox />
          </Box>
        </>
      )}
    </HeaderWrapper>
  );
}

export default Header;
